import { render, staticRenderFns } from "./VersionIntroduction.vue?vue&type=template&id=8e6137f0&scoped=true&"
import script from "./VersionIntroduction.vue?vue&type=script&lang=js&"
export * from "./VersionIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./VersionIntroduction.vue?vue&type=style&index=0&id=8e6137f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6137f0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/home/chofn/components/Header.vue').default,Footer: require('/home/chofn/components/Footer.vue').default})
